import React, {useEffect, useState, useRef} from 'react';
import EditProfile from "./EditProfile";
import {
    CircularProgress,
    Dialog,
    DialogContent,
    IconButton,
    InputLabel, ListItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import {
    AreaChart, LineChart, Line, BarChart, Bar,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip, ResponsiveContainer,
} from "recharts";
import {GetProfile, GetDashboard, CreditUser} from "../../../../api/api";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import Grid from "@mui/material/Grid";
import LastMonthSales from "../../../shared/metrics/LastMonthSales";

import Button from "@mui/material/Button";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import {savecredit, saveemail, savename} from "../../../redux/actions/contactsApp";
import {useDispatch, useSelector} from "react-redux";

var persian = require('persian-date')


function toPersianNum(num, dontTrim) {

    if (num === '') {
        return '';
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};


const Dashboard = () => {

    const [employecount, setEmployecount] = useState('');
    const [remain, setRemain] = useState('');
    const [cal, setCal] = useState(new persian());
    const {admin} = useSelector(({contactsApp}) => contactsApp);
    const [listchart, setListchart] = useState([]);
    const [today0, setToday0] = useState(new persian(cal.add('day', -7)));
    const [today1, setToday1] = useState(new persian(cal.add('day', -6)));
    const [today2, setToday2] = useState(new persian(cal.add('day', -5)));
    const [today3, setToday3] = useState(new persian(cal.add('day', -4)));
    const [today4, setToday4] = useState(new persian(cal.add('day', -3)));
    const [today5, setToday5] = useState(new persian(cal.add('day', -2)));
    const [today6, setToday6] = useState(new persian(cal.add('day', -1)));
    const dispatch = useDispatch();

    useEffect(() => {

        GetDashboard()
            .then((response) => {
                if (response.data.errorCode === 0) {

                    setRemain(response.data.credit);
                    setEmployecount(response.data.employeecount);

                    var listOfObjects = [];
                    for (let i = 0; i < 7; i++) {
                        var singleObj = {};

                        if (i === 0) {
                            singleObj['name'] = today1.format('YYYY/MM/DD');
                            singleObj['تعداد'] = response.data.pay0;
                        }
                        if (i === 1) {
                            singleObj['name'] = today2.format('YYYY/MM/DD');
                            // singleObj['تعداد'] = response.data.pay1;
                            singleObj['تعداد'] = response.data.pay1;
                        }
                        if (i === 2) {
                            singleObj['name'] = today3.format('YYYY/MM/DD');
                            singleObj['تعداد'] = response.data.pay2;
                        }
                        if (i === 3) {
                            singleObj['name'] = today4.format('YYYY/MM/DD');
                            // singleObj['تعداد'] = response.data.pay3;
                            singleObj['تعداد'] = response.data.pay3;
                        }
                        if (i === 4) {
                            singleObj['name'] = today5.format('YYYY/MM/DD');
                            singleObj['تعداد'] = response.data.pay4;
                        }
                        if (i === 5) {
                            singleObj['name'] = today6.format('YYYY/MM/DD');
                            singleObj['تعداد'] = response.data.pay5;
                        }
                        if (i === 6) {
                            singleObj['name'] = cal.format('YYYY/MM/DD');
                            // singleObj['تعداد'] = response.data.pay6;
                            singleObj['تعداد'] = response.data.pay6;
                        }
                        listOfObjects.push(singleObj);

                    }
                    setListchart(listOfObjects);


                }

            })
            .catch((error) => {


            });

        //  CreditUser()
        //     .then((response) => {
        //
        //         dispatch(savecredit(response.data.credit));
        //
        //
        //     })
        //     .catch((error) => {
        //
        //
        //     });
        //
        // GetProfile()
        //     .then((response) => {
        //
        //         dispatch(savename(response.data.profile.companyname));
        //         dispatch(saveemail(response.data.profile.email));
        //
        //
        //     })
        //     .catch((error) => {
        //
        //
        //     });


    }, []);


    return (

        <React.Fragment>


            <JumboCardQuick
                title={'داشبورد'}
                wrapperSx={{p: 3}}
            >


                <Grid style={{width: '100%', marginLeft: 5}} container>
                    <Grid style={{marginTop: 5, width: '100%'}} item lg={6}>
                        {/*<JumboCardQuick style={{width: '100%', fontWeight: 'bold', fontFamily: 'Iran'}}*/}
                        {/*                title={"مدیریت اعتبار"}*/}
                        {/*>*/}

                        {/*    /!*<div className="iran-font" style={{marginBottom: 10}}>*!/*/}
                        {/*    /!*    میزان افزایش اعتبار خود را وارد کنید*!/*/}
                        {/*    /!*</div>*!/*/}

                        {/*    <TextField*/}
                        {/*        value={description}*/}
                        {/*        onChange={onDescription}*/}
                        {/*        fullWidth label="توضیحات"*/}
                        {/*        placeholder="توضیحات درباره تراکنش"*/}
                        {/*        multiline*/}
                        {/*        rows={2}*/}
                        {/*        maxRows={4}*/}
                        {/*    />*/}


                        {/*    <div style={{display: 'flex', marginTop: 20, flexDirection: 'column',}}>*/}


                        {/*        <Button variant="contained" onClick={onaddcredit}*/}
                        {/*                style={{marginTop: 20}}*/}
                        {/*        >*/}
                        {/*            {loaderadd ?*/}
                        {/*                <CircularProgress style={{color: '#ffffff'}} size={24}/>*/}
                        {/*                :*/}
                        {/*                <div style={{*/}
                        {/*                    fontSize: 17,*/}
                        {/*                    fontFamily: 'Iran',*/}
                        {/*                    fontWeight: 'bold',*/}
                        {/*                    color: '#fff'*/}
                        {/*                }}>{value}*/}
                        {/*                </div>*/}
                        {/*            }*/}

                        {/*        </Button>*/}


                        {/*    </div>*/}


                        {/*</JumboCardQuick>*/}


                        <JumboCardQuick style={{width: '100%', height: '100%'}}
                        >
                            {admin ?
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    {/*<div className="iran-font"*/}
                                    {/*     style={{fontSize: 20, fontWeight: 'bold', marginTop: 20}}>*/}
                                    {/*    مانده حساب*/}
                                    {/*    : {toPersianNum(Number(remain).toLocaleString())} تومان*/}
                                    {/*</div>*/}
                                    <div className="iran-font"
                                         style={{fontSize: 20, fontWeight: 'bold', marginTop: 5}}>تعداد سازمان ها
                                        : {toPersianNum(Number(employecount).toLocaleString())} سازمان
                                    </div>
                                </div>

                                :
                                <div style={{display: 'flex', flexDirection: 'column'}}>
                                    <div className="iran-font"
                                         style={{fontSize: 20, fontWeight: 'bold', marginTop: 20}}>
                                        مانده حساب
                                        : {toPersianNum(Number(remain).toLocaleString())} تومان
                                    </div>
                                    <div className="iran-font"
                                         style={{fontSize: 20, fontWeight: 'bold', marginTop: 5}}>تعداد کارمندان
                                        : {toPersianNum(Number(employecount).toLocaleString())} نفر
                                    </div>
                                </div>


                            }

                        </JumboCardQuick>


                    </Grid>

                    <Grid style={{marginTop: 5, width: '100%', paddingRight: 10}} item lg={6}>
                        <JumboCardQuick style={{width: '100%', height: '100%'}}
                        >


                            <div className="iran-font3" style={{
                                cursor: 'pointer',

                                fontSize: 16, color: '#000000',
                                fontWeight: 'bold',
                                marginRight: 5, marginTop: 20
                            }}>
                                تعداد خریدها بر اساس تاریخ
                            </div>


                            <div style={{
                                width: '100%', direction: 'ltr', display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center', marginTop: 20, marginBottom: 20
                            }}>


                                <div style={{width: '100%', height: 300, padding: 0}}>

                                    <ResponsiveContainer width="100%" height={300}>
                                        <LineChart
                                            data={listchart}
                                            syncId="anyId"
                                            margin={{
                                                top: 0,
                                                right: 0,
                                                left: 0,
                                                bottom: 0
                                            }}

                                        >
                                            <CartesianGrid strokeDasharray="3 3"/>
                                            <XAxis className="iran-font3" dataKey="name"/>
                                            <YAxis className="iran-font3"/>
                                            <Tooltip/>
                                            <Line type="monotone" dataKey="تعداد" stroke="#82ca9d" fill="#82ca9d"/>
                                        </LineChart>
                                    </ResponsiveContainer>


                                </div>


                            </div>


                        </JumboCardQuick>

                    </Grid>
                </Grid>


                {/*<div className="row" style={{width: '100%', marginRight: 1}}>*/}

                {/*    <div className="col-6" style={{padding: 0, paddingLeft: 5}}>*/}
                {/*        <div style={{*/}
                {/*            display: 'flex', justifyContent: 'center', flexDirection: 'column',*/}
                {/*            alignItems: 'center', background: '#0db3dc', borderRadius: 6, width: '100%', height: 80*/}
                {/*        }}>*/}

                {/*            /!*<div style={{display:'flex',justifyContent: 'center',alignItems: 'center'}}>*!/*/}
                {/*            /!*                *!/*/}
                {/*            /!*</div>*!/*/}

                {/*            <div>رزروهای امروز</div>*/}
                {/*            <div*/}
                {/*                style={{marginTop: 5}}>{toPersianNum(2)}</div>*/}


                {/*        </div>*/}
                {/*    </div>*/}


                {/*    <div className="col-6" style={{padding: 0, paddingRight: 5}}>*/}
                {/*        <div style={{*/}
                {/*            display: 'flex', justifyContent: 'center', flexDirection: 'column',*/}
                {/*            alignItems: 'center', background: '#673ab7', borderRadius: 6, width: '100%', height: 80*/}
                {/*        }}>*/}

                {/*            <div>رزروهای فردا</div>*/}
                {/*            <div*/}
                {/*                style={{marginTop: 5}}>{toPersianNum(5)}</div>*/}

                {/*        </div>*/}
                {/*    </div>*/}


                {/*</div>*/}
                {/*<div className="row" style={{width: '100%', marginRight: 1, marginTop: 10}}>*/}

                {/*    <div className="col-6" style={{padding: 0, paddingLeft: 5}}>*/}
                {/*        <div style={{*/}
                {/*            display: 'flex', justifyContent: 'center', flexDirection: 'column',*/}
                {/*            alignItems: 'center', background: '#673ab7', borderRadius: 6, width: '100%', height: 80*/}
                {/*        }}>*/}

                {/*            /!*<div style={{display:'flex',justifyContent: 'center',alignItems: 'center'}}>*!/*/}
                {/*            /!*                *!/*/}
                {/*            /!*</div>*!/*/}

                {/*            <div>رزروهای هفته قبل</div>*/}
                {/*            <div*/}
                {/*                style={{marginTop: 5}}>{toPersianNum(8)}</div>*/}


                {/*        </div>*/}
                {/*    </div>*/}


                {/*    <div className="col-6" style={{padding: 0, paddingRight: 5}}>*/}
                {/*        <div style={{*/}
                {/*            display: 'flex', justifyContent: 'center', flexDirection: 'column',*/}
                {/*            alignItems: 'center', background: '#0db3dc', borderRadius: 6, width: '100%', height: 80*/}
                {/*        }}>*/}

                {/*            <div>رزروهای ماه قبل</div>*/}
                {/*            <div*/}
                {/*                style={{marginTop: 5}}>{toPersianNum(8)}</div>*/}

                {/*        </div>*/}
                {/*    </div>*/}


                {/*</div>*/}


            </JumboCardQuick>


        </React.Fragment>


    );


};

export default Dashboard;